/** Mobile AudioSpeaker at `#72AA6080` — not a solid green play chip. */
export function TermSpeaker({ label, onPlay }: { label: string; onPlay: () => void }) {
  return (
    <button type="button" onClick={onPlay} aria-label={`Hear ${label}`} className="shrink-0">
      <svg width="42" height="42" viewBox="0 0 42 42" fill="none" aria-hidden>
        <circle cx="21" cy="21" r="21" fill="#72AA60" fillOpacity="0.5" />
        <path
          d="M24 34.088V31.013c2.25-.65 4.063-1.9 5.438-3.75S31.5 23.313 31.5 20.963s-.688-4.45-2.063-6.3-3.187-2.1-5.437-2.75V7.838c3.1.7 5.625 2.269 7.575 4.706S34.5 17.788 34.5 20.963s-.975 6.981-2.925 9.419-4.475 3.006-7.575 3.706ZM7.5 25.5v-9H13.5L21 9v24l-7.5-7.5H7.5Zm16.5 1.5V14.925c1.175.55 2.094 1.375 2.756 2.475.663 1.1.994 2.3.994 3.6 0 1.275-.331 2.457-.994 3.544-.662 1.088-1.581 1.906-2.756 2.456ZM18 16.275 14.775 19.5H10.5v3h4.275L18 25.725v-9.45Z"
          fill="#fff"
          fillOpacity="0.8"
        />
      </svg>
    </button>
  );
}
